module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaAtividades,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui atividades.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.descricao",
      fn: function(props) {
        return [(_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) ? _c('div', [_c('router-link', {
          attrs: {
            "to": {
              name: 'EditarAtividade',
              params: {
                idProjeto: _vm.idProjeto,
                idAtividade: props.item.id
              }
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.descricao) + "\n        ")])], 1) : _c('div', [_vm._v("\n        " + _vm._s(props.item.descricao) + "\n      ")])]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaAtividades.length) + " atividades\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toCriarAtividade
    }
  }, [_vm._v("Nova Atividade")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toAvancar
    }
  }, [_vm._v("Avançar")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ccfde22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/editar-projeto/projeto-editar-atividades.vue
// module id = 542
// module chunks = 0